module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "install",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onInstall($event)
      }
    }
  }, [_c('img', {
    staticClass: "install_picto",
    attrs: {
      "src": "favicon-32x32.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "install_label color-blue-500"
  }, [_vm._v("Installer l'application Yaniv Scores ?")]), _vm._v(" "), _c('div', {
    staticClass: "install_close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onClose($event)
      }
    }
  }, [_vm._v("✕")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e31c7de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Install.vue
// module id = 111
// module chunks = 2